module.exports = __webpack_public_path__ + "img/check.d6ec1edd.svg";